import { tags } from './tags';

function endpoints(builder) {
  return {
    getProductReleaseFeatures: builder.query({
      query: ({
        productId,
        version = '',
        limit = 100,
        offset = 0,
      }) => `actions/frontend/products/get-release-features?productId=${productId}&version=${version}&limit=${limit}&offset=${offset}`,
      providesTags: tags,
    }),
    getProductInstructionVideos: builder.query({
      query: ({
        productId,
        limit = 100,
        offset = 0,
      }) => `actions/frontend/products/get-instruction-videos?productId=${productId}&limit=${limit}&offset=${offset}`,
      providesTags: tags,
    }),
    getProductOnlineCourses: builder.query({
      query: ({
        productId,
        limit = 100,
        offset = 0,
      }) => `actions/frontend/products/get-online-courses?productId=${productId}&limit=${limit}&offset=${offset}`,
      providesTags: tags,
    }),
    getProductDocumentation: builder.query({
      query: ({
        productId,
        limit = 100,
        offset = 0,
      }) => `actions/frontend/products/get-documentation?productId=${productId}&limit=${limit}&offset=${offset}`,
      providesTags: tags,
    }),
    getProductModulesAndParts: builder.query({
      query: ({
        productId,
      }) => `actions/frontend/products/get-modules-and-parts?productId=${productId}`,
      providesTags: tags,
    }),
    getProductMarketingItems: builder.query({
      query: ({
        productId,
        limit = 100,
        offset = 0,
      }) => `actions/frontend/products/get-marketing-items?productId=${productId}&limit=${limit}&offset=${offset}`,
      providesTags: tags,
    }),
    getRelatedProducts: builder.query({
      query: ({
        productId,
        limit = 100,
        offset = 0,
      }) => `actions/frontend/products/get-related-products?productId=${productId}&limit=${limit}&offset=${offset}`,
      providesTags: tags,
    }),
  };
}

export { endpoints };
